module.exports = __webpack_public_path__ + "media/images/org-earth-icon-0f259faa.svg";